export default "__VITE_ASSET__CDs6Wfk5__"